






































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class ChangeFlightDayModal extends Vue {
  radios: boolean = true;
  dialog: boolean = true;
  mockData: any[] = [];
  headers: any[] = [];
  mockDataTableSearch: any[] = [];
  headersTableSearch: any[] = [];
  mockDataPassengers: any[] = [];
  headersPassengers: any[] = [];
  mockDataPassengerClass: any[] = [];
  headersPassengerClass: any[] = [];
  mockDataPaymentDetail: any[] = [];
  headersPaymentDetail: any[] = [];

  isOpenFlightSearch: boolean = true;
  isOpenPassengerClass: boolean = false;
  isOpenPassengers: boolean = true;
  isOpenPaymentDetail: boolean = false;
  date: Date = null;

  created() {
    (this.headersTableSearch = [
      { text: "", align: "start", filterable: false, value: "" },
      { text: "Havayolu Adı", value: "companies" },
      { text: "Kalkış-Varış", value: "destination" },
      { text: "Uçuş Numarası", value: "flightNo" },
      { text: "Fiyat", value: "price" },
      { text: "Kalkış Tarihi", value: "departureDate" },
      { text: "Varış Tarihi", value: "arrivalDate" },
    ]),
      (this.mockDataTableSearch = [
        {
          companies: " URAL AIRLINES - U6 1518",
          destination: "16.03.2021 IST-MCX 18:00",
          flightNo: "U6 1518",
          price: "1,195 RUB",
          departureDate: " 02/05/2021 13:30 ",
          arrivalDate: "02/05/2021 15:50 ",
        },
      ]),
      (this.headersPassengers = [
        { text: "", value: "passengerType" },
        { text: "Uçuş Sınıfı", value: "flightClass" },
        { text: "Cinsiyet", value: "gender" },
        { text: "İsim", value: "name" },
        { text: "Doğum Tarihi", value: "birthday" },
        { text: "Pasaport Seri Numarası", value: "serialNumber" },
        { text: "PasaportNo", value: "passportNo" },
        { text: "Pasaport Geçerlilik Tarihi", value: "validityDate" },
      ]),
      (this.mockDataPassengers = [
        {
          passengerType: "Yetişkin",
          flightClass: "X-A",
          gender: "Erkek",
          name: "MAKARY IVONCHYK",
          birthday: "05/10/1994",
          serialNumber: "MP",
          passportNo: "4420525",
          validityDate: "18/09/2029",
        },
      ]),
      (this.headersPassengerClass = [
        { text: "Uçus Sınıfı", value: "flightClass" },
        { text: "Uçuş Bölümü", value: "flightSegment" },
        { text: "Yolcu Türü", value: "passengerType" },
        { text: "Fiyat", value: "price" },
      ]),
      (this.mockDataPassengerClass = [
        {
          flightClass: "X",
          flightSegment: "A",
          passengerType: "Yetişkin",
          price: "1195",
        },
      ]),
      (this.headersPaymentDetail = [
        { text: "PNR", value: "pnr" },
        { text: "Havayolu Adı", value: "companies" },
        { text: "Kalkış-Varış", value: "destination" },
        { text: "Uçuş Türü", value: "flightType" },
        { text: "Sipariş Durumu", value: "orderStatus" },
        { text: "Yolcu Sayısı", value: "passangerCount" },
        { text: "ToplamÜcret", value: "totalPrice" },
      ]),
      (this.mockDataPaymentDetail = [
        {
          pnr: "53644",
          companies: "URAL AIRLINES - U6 1518",
          destination: "05.05.2021 AER - DME 11:00",
          flightType: "Tek Yön",
          orderStatus: "Ödeme alındı",
          passangerCount: "1",
          totalPrice: "1,350.00 RUB",
        },
      ]);
  }

  data() {
    return {
      fromAirportsItems: ["Anapa,Rusya / AAQ", "Abakan,Rusya / ABA"],
      fromAirports: [],

      toAirportsItems: [
        "Antalya,Turkey (AYT-Antalya Int) / AYT",
        "Akabe,Urdun / AQJ",
      ],
      toAirports: [],
    };
  }

  closeDialog() {
    this.$emit("closed");
  }
  openFlightSearch() {
    this.isOpenFlightSearch = true;
  }
  closeFlightSearch() {
    this.isOpenFlightSearch = false;
  }

  openPassengers() {
    this.isOpenPassengers = true;
  }
  closePassengers() {
    this.isOpenPassengers = false;
  }

  openPassengerClass() {
    this.isOpenPassengerClass = true;
  }
  closePassengerClass() {
    this.isOpenPassengerClass = false;
  }

  openPaymentDetail() {
    this.isOpenPaymentDetail = true;
  }
  closePaymentDetail() {
    this.isOpenPaymentDetail = false;
  }
}
